import CommonInternalTransferPage from './CommonInternalTransferPage';

export default CommonInternalTransferPage;
